import Box from '@mui/material/Box';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import FoodBankIcon from '@mui/icons-material/FoodBank';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StarsIcon from '@mui/icons-material/Stars';
import { useTranslation } from 'react-i18next';
import {
  inventoryReportSx,
  kitchenReportSx,
  laborReportsSx,
  salesReportSx,
  menuReportsSx,
  iconSx,
  favoritesReportsSx,
} from './styles';

type ReportIconsProps = {
  sectionHeader: string;
};

export default function ReportIcons({ sectionHeader }: ReportIconsProps) {
  const { t } = useTranslation();

  function getIconForSection(header: string): JSX.Element | null {
    switch (header) {
      case t('admin.centralReportsPage.sectionHeaders.favorites'):
        return (
          <Box sx={favoritesReportsSx}>
            <StarsIcon sx={iconSx} aria-label={`${t('admin.centralReportsPage.sectionHeaders.favorites')} Icon`} />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.laborReports'):
        return (
          <Box sx={laborReportsSx}>
            <PeopleAltIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.laborReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.inventoryReports'):
        return (
          <Box sx={inventoryReportSx}>
            <InventoryIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.inventoryReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.salesReports'):
        return (
          <Box sx={salesReportSx}>
            <MonetizationOnIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.salesReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.kitchenReports'):
        return (
          <Box sx={kitchenReportSx}>
            <FoodBankIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.kitchenReports')} Icon`}
            />
          </Box>
        );
      case t('admin.centralReportsPage.sectionHeaders.menuReports'):
        return (
          <Box sx={menuReportsSx}>
            <RestaurantMenuIcon
              sx={iconSx}
              aria-label={`${t('admin.centralReportsPage.sectionHeaders.menuReports')} Icon`}
            />
          </Box>
        );
      default:
        return null;
    }
  }

  return getIconForSection(sectionHeader);
}
